import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';

@Component({
    selector: 'google-login',
    templateUrl: './login-google.component.html',
    styleUrls: ['./login-google.component.scss'],
    standalone: false
})
export class LoginGoogleComponent implements OnInit {
  version = environment.version
  boxVersion:any = "-";
  workspaceVersion:any = "-";sanitizedUrl: any;
  isBrowser: boolean;
;
  buildCount: any = "";
  state:any;
  email:any;
  profile:any;

  constructor(
   @Inject(PLATFORM_ID) platformId?: Object
   ) {
     this.isBrowser = isPlatformBrowser(platformId);
     if(!this.isBrowser) return;
  }

  ngOnInit(): void {
    console.log("google login")
  }

  login() {
    const popupWindow = window.open(`${window.location.origin}/login-popup`, 'Popup', 'width=500,height=600');
    if (popupWindow) {
      popupWindow.focus();
    } else {
      alert('Please allow popups for this website');
    }
  }

}

